import authRequest from '@/modules/auth-request.js';
import http from '@/modules/http';
import ENV_VARS from '@/modules/env-vars.js';

export default {

	setMarketingFlag(payload){
		return authRequest.post('CONSENT_API://articles/tekmarketing', {
			form: 'Yes, I would like to receive marketing communications about the latest Tektronix products, offers and events.',
			answer: payload,
			client: ENV_VARS.ACCOUNT_URL,
		}).then(http.resolveData, http.rejectData);
	},

	getMarketingFlag(payload){
		return authRequest.get('CONSENT_API://articles/tekmarketing').then(http.resolveData, http.rejectData);
	}

};



// WEBPACK FOOTER //
// ./src/modules/consent-api.js